// pedidos/HorarioExcecao.js

export class HorarioExcecao {

  static Tipos = {
    FECHADO: 1,
    HORARIO_ESPECIAL: 2
  };

  static TiposLista = [
    { value: 1, label: "Fechado" },
    { value: 2, label: "Horário Especial" }
  ];

  static getDescricaoTipo(tipo) {
    const encontrado = this.TiposLista.find(t => t.value === tipo);
    return encontrado ? encontrado.label : "";
  }

  constructor(data = null) {
    this.id = data?.id ?? 0;
    this.tipo = data?.tipo ?? 1;
    this.motivo = data?.motivo ?? "";
    this.dataHoraInicio = data?.dataHoraInicio ?? null;
    this.dataHoraFim = data?.dataHoraFim ?? null;
  }
}
